import React, { useCallback, useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";
import ParameterNameField from "./ParameterNameField";
import ParameterValueField from "./ParameterValueField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

export function EditParameterPopup({ selectedParameter, closePopup, confirm }) {

    const [parameter, setParameter] = useState(selectedParameter);

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onContinueClick = () => {
        closePopup();
        confirm(parameter);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-edit-parameter-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <SlidersHorizontal size={18} />
                        </div>
                        <div>
                            <h4 id="oct-edit-parameter-title" className="oct-shared-popup__title">Edit Parameter</h4>
                            <p className="oct-shared-popup__subtitle">Update the value used across matching rules and outputs.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close edit parameter popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <ParameterNameField value={parameter.name} onChange={(value) => setParameter({ ...parameter, name: value })} disabled={true} />
                    <ParameterValueField value={parameter.value} onChange={(value) => setParameter({ ...parameter, value })} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!parameter.name || !parameter.value}
                        onClick={onContinueClick}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    )

}

export default EditParameterPopup;
